export enum ErrorCode
{
    INVALID_COMMAND = 4000,
    DEVICE_NOT_FOUND = 4001,
    CATALOG_OR_FILE_NOT_FOUND = 4002,
    WRONG_FIEID = 4003,
    UPLOADED_FILE_ERROR = 4004,
    DEVICE_NOT_REGISTERED = 4005,
    DEVICE_REGISTRATION_WAITING_TIME_EXCEEDED = 4006,
    WRONG_DEVICE_REGISTRATION_PIN = 4007,
    USER_ALREADY_HAS_THIS_DEVICE_ASSIGNED = 4008,
    WRONG_DEVICE_TYPE = 4009,
    USER_IS_NOT_AN_ADMIN_OF_THIS_DEVICE = 4010,
    USER_NOT_FOUND = 4011,
    USER_DOES_NOT_HAVE_THIS_DEVICE_ASSIGNED = 4012,
    CATALOG_NOT_FOUND = 4013,
    FILE_WITH_THE_GIVEN_NAME_ALREADY_EXISTS_IN_THE_FOLDER = 4014,
    WRONG_FILENAME = 4015,
    FILE_NOT_FOUND = 4016,
    FILE_IS_CORRUPTED_CHECKSUM_DOES_NOT_MATCH = 4017,
    GROUP_NAME_TOO_SHORT = 4018,
    USER_IS_NOT_ASSIGNED_TO_THIS_GROUP = 4019,
    USER_IS_NOT_AN_ADMIN_OF_THIS_GROUP = 4020,
    GROUP_NOT_FOUND = 4021,
    DEVICE_ALREADY_ADDED_TO_THIS_GROUP = 4022,
    DEVICE_NOT_ASSIGNED_TO_THIS_GROUP = 4023,
    USER_DOES_NOT_HAVE_THIS_SUBSCRIPTION = 4024,
    WRONG_FIRST_NAME = 4025,
    WRONG_LAST_NAME = 4026,
    WRONG_PHONE_NUMBER = 4027,
    WRONG_TOKEN_REQUEST_MODEL = 4028,
    WRONG_GRANT_TYPE = 4029,
    TOKEN_NOT_FOUND = 4030,
    USER_IS_THE_ONLY_ADMINISTRATOR_OF_THE_PRINTER_UNABLE_TO_REMOVE_DEVICE = 4031,
    WRONG_ROLE = 4032,
    CATALOG_CREATING_FAILED = 4033,
    MAIL_ADDRESS_CANNOT_BE_EMPTY = 4034,
    MAIL_ADDRESS = 4035,
    MAIL_IS_USED_BY_ANOTHER_USER = 4036,
    PRINTER_DOES_NOT_REACT_TO_THE_COMMAND = 4037,
    NEW_PASSWORD_AND_CONFIRM_PASSWORD_FIELDS_ARE_NOT_EQUAL = 4038,
    CURRENT_PASSWORD_IS_INVALID = 4039,
    NEW_PASSWORD_IS_TOO_SHORT = 4040,
    NEW_PASSWORD_DOES_NOT_MEET_THE_REQUIREMENTS = 4041,
    WRONG_LOGIN_OR_PASSWORD = 4042,
    NO_DEVICES_SELECTED = 4043,
    TOO_MANY_FILES_SELECTED = 4044,
    ONLY_RCODE_FILES_ALLOWED = 4045,
    MULTIPRINT_START_FAILED = 4046,
    UPLOAD_TO_DEVICE_ERROR = 4047,
    WRONG_MULTIPRINT_ID = 4048,
    YOU_ARE_NOT_AN_OWNER_OF_THIS_MULTIPRINT = 4049,
    TEAM_DOESNT_EXIST = 4050,
    ONLY_OWNER_CAN_DELETE_TEAM = 4051,
    ONLY_OWNER_CAN_MANAGE_TEAM = 4052,
    USER_DOESNT_EXIST_IN_THIS_TEAM = 4053,
    USER_ALREADY_HAS_THIS_ROLE = 4054,
    TEAM_DOESNT_HAVE_THIS_DEVICE_ASSIGNED = 4055,
    TEAM_HAS_THIS_DEVICE_ASSIGNED_ALREADY = 4056,
    USER_IS_ALREADY_ASSIGNED_TO_THIS_TEAM = 4057,
    THE_SUBJECT_OF_THE_REPORTED_PROBLEM_IS_TOO_LONG = 4058,
    THE_MESSAGE_OF_THE_REPORTED_PROBLEM_IS_TOO_LONG = 4059,
    INVITATION_IS_INCORRECT = 4060,
    THE_INVITATION_DOES_NOT_EXIST = 4061,
    MATERIAL_DOES_NOT_EXIST = 4062,
    THE_DATA_ENTERED_CANNOT_BE_EMPTY = 4063,
    MATERIAL_ALREADY_EXISTS = 4064,
    DEVICE_TYPE_ALREADY_EXISTS = 4065,
    DEVICE_TYPE_DOES_NOT_EXIST = 4066,
    YOU_NEED_TO_BE_DEVICE_OWNER_TO_PERFORM_UPDATE = 4067,
    CANCEL_FILE_UPLOAD = 4068,
    PRINTING_CAN_BE_INTERRUPTED_ONLY_BY_THE_PRINT_OWNER_OR_THE_PRINTER_OWNER = 4069,
    DEVICE_NAME_CANNOT_BE_EMPTY = 4070,
    NO_CONNECTED_DEVICES = 4071,
    NO_REGISTERED_DEVICES = 4072,
    ALL_REGISTERED_DEVICES_HAVE_ALREADY_BEEN_ADDED_TO_INCLOUD = 4073,
    DEVICE_LIMIT_EXCEEDED = 4074,
    REQUESTED_FILE_EXCEEDS_TRANSFER_LIMIT = 4075,
    REQUESTED_ADDON_NOT_FOUND = 4076,
    INCORRECT_QUANTITY = 4077,
    PAYMENT_FAILED_TO_INITIALIZE = 4078,
    SUBSCRIPTION_NOT_FOUND = 4079,
    FAILED_TO_SAVE_TO_DATABASE = 4080,
    USER_LIMIT_EXCEEDED = 4081,
    SHELF_NOT_FOUND = 4082,
    ONLY_OWNER_CAN_MANAGE_SHELF = 4083,
    ONLY_OWNER_CAN_DELETE_SHELF = 4084,
    DEVICE_DOESNT_HAVE_CAMERA_FEATURE = 4085,
    NOT_POSSIBLE_ADD_ALL_USERS = 4086,
    USER_DOESNT_EXIST_IN_YOUR_ORGANIZATION = 4087,
    DEVICE_CANT_BE_UPDATED_IF_IS_WORKING = 4088,
    DEVICE_REGISTRATION_PIN_HAS_EXPIRED = 4089,
    DEVICE_JOB_NOT_FOUND = 4090,
    VALIDITY_OF_THE_VOUCHER_IS_TOO_SHORT = 4091,
    VOUCHER_TYPE_DOES_NOT_EXIST = 4092,
    VOUCHER_FOR_A_SPECIFIC_USER_MUST_BE_ONE_TIME_ONLY = 4093,
    VOUCHER_VALUE_MUST_BE_GREATER_THAN_0 = 4094,
    VOUCHER_WITH_SUCH_A_CODE_HAS_ALREADY_BEEN_GENERATED = 4095,
    VOUCHER_CODE_CANNOT_BE_EMPTY = 4096,
    VOUCHER_DOES_NOT_EXIST = 4097,
    VOUCHER_HAS_BEEN_USED = 4098,
    VOUCHER_HAS_EXPIRED = 4099,
    SERVER_INTERNAL_ERROR = 4100,
    VOUCHER_POOL_HAS_BEEN_USED_UP = 4101,
    THE_VALIDITY_OF_THE_VOUCHER_CANNOT_EXCEED_3_MONTHS = 4102,
    YOUR_PACKAGE_IS_TOO_LOW_TO_USE_THIS_TYPE_OF_VOUCHER = 4103,
    TYPE_OF_VOUCHER_CANNOT_BE_USED_WITH_A_PAID_PACKAGE = 4104,
    A_USED_VOUCHER_CANNOT_BE_DELETED = 4105,
    VALIDITY_OF_THE_RESOURCES_IS_TOO_SHORT = 4106,
    RESOURCES_CANNOT_BE_CREATED_FOR_THIS_USER = 4107,
    OUT_OF_RESELLER_RESOURCES = 4108,
    NOT_ENOUGH_RESOURCES_TO_CREATE_A_VOUCHER = 4109,
    FILE_UPLOADING_EXCEPTION_ON_SERVER = 4110,
    GETTING_TOKEN_EXCEPTION_ON_SERVER = 4111,
    REFRESHING_TOKEN_EXCEPTION_ON_SERVER = 4112,
    DEVICE_NO_LIVE_STREAM_SUPPORT = 4113,
    DEVICE_OWNER_NOT_ENOUGH_TRANSFER = 4114,
    DEVICE_ALREADY_HAS_LATEST_FIRMWARE = 4115,
    PRINTER_IS_BUSY = 4116,
    COULD_NOT_ADD_STOLEN_DEVICE = 4117,
    COULD_NOT_DELETE_STOLEN_DEVICE = 4118,
    DEVICE_TYPE_SPECIFICATION_DOES_NOT_EXIST = 4119,
    DEVICE_DOES_NOT_EXIST_ON_THIS_SHELF = 4120,
    USER_DOES_NOT_EXIST_ON_THIS_SHELF = 4121,
    DEVICE_DOES_NOT_EXIST_ON_THIS_TEAM = 4122,
    RESELLER_DOES_NOT_EXIST = 4123,
    REPORTED_PROBLEM_DOES_NOT_EXIST = 4124,
    CAMERA_PREVIEW_DOES_NOT_EXIST = 4125,
    DEVICE_NOT_FOUND_IN_MULTISTREAM = 4126,
    TERMS_OF_USE_NOT_FOUND = 4127,
    NEW_VERSION_FEATURES_NOT_FOUND = 4128,
    CANNOT_EDIT_HOME_DIRECTORY = 4131,
    EXTRUDER_POSITION_DOES_NOT_EXIST = 4132,
    OPERATION_NOT_ALLOWED_IN_DIRECTORY = 4133,
    INVALID_2FA_CODE = 4134
}